import type { FocusEvent } from 'react';
import React, { useState } from 'react';
import type icons from '../../markons/markons';
import classNames from 'classnames';
import { TestIdConsumer } from '../contexts/testid';
import Icon from './Icon';

export interface RadioButtonProps extends React.ComponentPropsWithoutRef<'input'> {
    testId?: string;
    icon?: ValueOf<typeof icons>
}

const RadioButton: React.FC<RadioButtonProps> = ({
    children,
    checked,
    disabled,
    testId,
    icon,
    onFocus,
    onBlur,
    ...attrs
}) => {
    const [focused, setFocused] = useState(false);

    const handleFocus = (event: FocusEvent<HTMLInputElement>) => {
        setFocused(true);
        onFocus?.(event);
    };

    const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
        setFocused(false);
        onBlur?.(event);
    };

    return (
        <TestIdConsumer id={testId}>
            {(resolvedTestId) => (
                <label
                    className={classNames('react', 'checkable', { focused, checked, disabled })}
                    data-testid={resolvedTestId}
                >
                    <input
                        type="radio"
                        {...attrs}
                        checked={checked}
                        disabled={disabled}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                    />
                    {icon != null && <Icon name={icon} />}
                    <span>{children}</span>
                </label>
            )}
        </TestIdConsumer>
    );
};

export default RadioButton;
